"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _rodal = _interopRequireDefault(require("rodal")),
    _classnames = _interopRequireDefault(require("classnames"));

require("rodal/lib/rodal.css");

var _baseModal = require("../styles/baseModal"),
    _Icon = _interopRequireDefault(require("../../Icon")),
    BaseModal = function BaseModal(a) {
  var b = a.visible,
      c = a.onClose,
      d = a.children,
      e = a.className,
      f = a.styles;
  return _react["default"].createElement(_rodal["default"], {
    visible: b,
    onClose: c,
    closeOnEsc: !0,
    showCloseButton: !1,
    className: _baseModal.MODAL_CONTAINER
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _baseModal.MODAL)(f), "modal", e)
  }, _react["default"].createElement(_Icon["default"], {
    clickable: !0,
    className: (0, _classnames["default"])(_baseModal.CLOSE_ICON, "modal-close-icon"),
    name: "close",
    onClick: c,
    color: "regent",
    size: 15
  }), d));
},
    _default = BaseModal;

exports["default"] = _default;